import { Component, Input } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { Browser } from '@capacitor/browser';
import { addIcons } from 'ionicons';
import { arrowUpCircleOutline } from 'ionicons/icons';

@Component({
  selector: 'app-force-update-sheet',
  templateUrl: './force-update-sheet.component.html',
  styleUrls: ['./force-update-sheet.component.scss'],
  imports: [IonButton, IonIcon],
})
export class ForceUpdateSheetComponent {
  @Input() url = '';

  constructor() {
    addIcons({ arrowUpCircleOutline });
  }

  async openStore() {
    const url = this.url.startsWith('http') ? this.url : `https://${this.url}`;
    await Browser.open({ url });
  }
}
